import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Collapse } from "react-collapse";

import { INVOICE_LIST_DIALER_API } from "const/apiMethods";
import { checkPermissionsFor } from "store/storeHelpers";
import { withTranslation } from "hoc/WithTranslation";
import { Spacer } from "components/base/Spacer";
import { getISOTime, getDefaultDateRange } from "utils/helpers";
import m from "definedMessages";
import PaymentsTrafficReportsTable from "./PaymentsTrafficReportsTable";
import PaymentsSectionHeader from "components/Payments/PaymentsSectionHeader";
import CommonDateFilter from "components/Payments/CommonDateFilter";

const PaymentsTrafficReportsSection = ({
    paymentTrafficReportsItems,
    paymentTrafficReportsLoading,
    openModalRequestPayment,
    currencyName,
    getTrafficReportsList,
    globalSettings,
    accountJoinList,
    permissions,

    formatMessage
}) => {

    const { start: dateStart, end: dateEnd } = useMemo(() => getDefaultDateRange(6), []);

    const [filters, setFilters] = useState({
        start_end_date: [dateStart, dateEnd]
    });

    const [showTable, setShowTable] = useState(true);

    useEffect(() => {
        if (!checkPermissionsFor(INVOICE_LIST_DIALER_API)) {
            return;
        }
        const data = {
            filter: {
                start_date: getISOTime(dateStart),
                end_date: getISOTime(dateEnd)
            }
        };
        getTrafficReportsList(data);
    }, [permissions, getTrafficReportsList, dateStart, dateEnd]);

    const handleChangeFilters = useCallback((value) => {
        if (!value || !value.start_end_date || !value.start_end_date[0] || !value.start_end_date[1]) {
            return;
        }

        setFilters({
            start_end_date: value.start_end_date
        });

        const [start, end] = value.start_end_date;

        const start_date = new Date(start);
        start_date.setHours(0, 0, 0, 0);

        const end_date = new Date(end);
        end_date.setHours(23, 59, 59, 999);

        const normalizedRange = [start_date, end_date];

        const filterData = {
            start_date: getISOTime(start_date),
            end_date: getISOTime(end_date),
            start_end_date: normalizedRange
        };

        getTrafficReportsList({
            filter: filterData
        });
    }, [getTrafficReportsList]);

    return (
        <>
            <PaymentsSectionHeader
                title={formatMessage(m.trafficReports)}
                show={showTable}
                callback={() => {
                    setShowTable(prev => !prev);
                }}
            />

            <Collapse isOpened={showTable}>
                <div>
                    <Spacer />
                    <CommonDateFilter
                        filters={filters}
                        onChangeFilters={handleChangeFilters}
                    />

                    <Spacer />
                    <PaymentsTrafficReportsTable
                        data={paymentTrafficReportsItems}
                        loading={paymentTrafficReportsLoading}
                        {...{
                            globalSettings,
                            accountJoinList,
                            openModalRequestPayment,
                            currencyName
                        }}
                    />
                </div>
            </Collapse>
        </>
    );
};

export default withTranslation(PaymentsTrafficReportsSection);